import * as angular from 'angular';
import controller from './unfinishedCheckLists.controller';
import template from './unfinishedCheckLists.tpl.html';

export default angular.module('aps.directive.unfinishedCheckLists', [controller])
  .directive('apsUnfinishedCheckLists', unfinishedCheckListsDirective)
  .name;

function unfinishedCheckListsDirective() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'UnfinishedCheckListsCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {}
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/checks/unfinishedCheckLists.directive.ts